<template>
  <!-- <div class="comp-list-sort"> -->
  <jw-trigger trigger="click" unmount-on-close position="bl" :popup-visible="data.popupVisible" :show-arrow="true" :popup-offset="4" arrow-class="arrow-filter" popup-container=".comp-ly-advanced-filter">
    <jw-button class="list-container-btn" :type="sortCount === 0 ? 'secondary' : 'outline'" :class="sortCount > 0 ? 'filter-btn' : 'default-btn'" size="small" @click="openSortPopup">
      <template #icon>
        <qfei-icon-ascending-order-outlined />
      </template>
      <jw-space size="mini">
        <span v-if="sortCount">{{ sortCount }}</span>
        <span>排序</span>
      </jw-space>
    </jw-button>

    <template #content>
      <div class="sort-main">
        <div class="sort-condition">
          <div class="sort-title">
            <jw-space>
              <div class="set-sort-condition">设置排序条件</div>
              <jw-tooltip :content-style="{ maxWidth: '440px' }">
                <template #content>
                  <ul class="prompt-text">
                    <li>最多同时设置5个排序规则</li>
                  </ul>
                </template>
                <icon-question-circle class="hand" />
              </jw-tooltip>
            </jw-space>
          </div>
          <div class="sort-operation">
            <jw-button type="text" size="small" class="default-sort" @click="defaultSortCondition">恢复默认</jw-button>
            <jw-button type="text" size="small" @click="deleteSortConditionAll" class="clear-condition">清空所有</jw-button>
          </div>
        </div>
        <div class="sort-list">
          <draggable itemKey="index" :list="data.fieldSort" handle=".mover">
            <template #item="{ element, index }">
              <div class="draggable-item">
                <icon-drag-dot-vertical size="20" class="mover icon-mover" />
                <div class="task-is-required">
                  <template v-if="element.fieldKey != '' && fieldLists?.filter((item) => item.fieldKey == element.fieldKey)?.length == 0">
                    <jw-input error :model-value="element.fieldName" style="color: rgb(var(--red-6))" />
                  </template>
                  <!-- fieldStatus  1 正常 2 停用 -->
                  <template v-else-if="element.fieldStatus != 2">
                    <jw-select v-model="element.fieldKey" :disabled="element.fieldStatus == 2" allow-clear allow-search placeholder="请选择排序字段" :default-popup-visible="visibleMap[`show-${index}`]" @change="fieldChange(data.fieldSort, fieldLists, 9)" @popup-visible-change="(event) => selectChangePopup(event, element)">
                      <template #label="{ data }">
                        <div class="select-group-field-label">{{ data?.label }}</div>
                      </template>
                      <template v-for="(item, index) in fieldLists" :key="index">
                        <fh-divider v-if="item?.isFirstTypeOne"></fh-divider>
                        <jw-option :value="item.fieldKey" :disabled="item.disabled">
                          {{ item.fieldName }}
                        </jw-option>
                      </template>
                    </jw-select>
                  </template>
                  <!-- 布局字段停用 -->
                  <template v-else-if="element.fieldStatus == 2">
                    <jw-input error :model-value="'已停用字段'" placeholder="已停用字段" style="color: rgb(var(--red-6))" />
                  </template>
                </div>
                <div class="field-sort">
                  <jw-tooltip :content="'升序'">
                    <jw-button size="small" type="text" class="icon-sort-icon hand" @click="setfieldSort(element, true, index)" :class="[element.fieldSort ? 'field-sort-selected' : 'field-sort-up']">
                      <qfei-icon-ascending-order-outlined :disabled="element.fieldStatus == 2" />
                    </jw-button>
                  </jw-tooltip>
                  <jw-tooltip :content="'降序'">
                    <jw-button size="small" type="text" class="icon-sort-icon hand" @click="setfieldSort(element, false, index)" :class="[element.fieldSort ? 'field-sort-up' : 'field-sort-selected']">
                      <qfei-icon-descending-order-outlined :disabled="element.fieldStatus == 2" />
                    </jw-button>
                  </jw-tooltip>
                  <jw-tooltip :content="'删除'">
                    <jw-button size="small" type="text" class="icon-sort-icon hand" @click="deleteSortField(index)" :class="['delete-icon']">
                      <qfei-icon-delete-outlined />
                    </jw-button>
                  </jw-tooltip>
                </div>
              </div>
            </template>
          </draggable>
        </div>
        <div class="btn-sort">
          <div class="add-condition">
            <jw-button size="small" type="text" class="add-sort-condition" v-if="data.fieldSort?.length < 5" @click="addFieldSort">
              <template #icon>
                <qfei-icon-add-two-outlined />
              </template>
              添加排序规则
            </jw-button>
          </div>
          <jw-button class="sort-confirm" @click="sortConfirm" type="primary" size="small">确认</jw-button>
        </div>
      </div>
    </template>
  </jw-trigger>
  <div v-if="showOverlay" class="overlay" @click.stop="hideLay"></div>
  <!-- </div> -->
</template>

<script setup>
import { layoutService } from '@/api/';
import { reactive, ref, computed, watch } from 'vue';
import draggable from 'vuedraggable';
import { useFilterListStore } from '@/store';
import { constFieldSort } from '@/utils/const';
import { Message } from '@arco-design/web-vue';
import { QfeiIconAscendingOrderOutlined, QfeiIconAddTwoOutlined, QfeiIconDeleteOutlined, QfeiIconDescendingOrderOutlined } from '@qfei-design/icons-vue';
import useSortGroup from '@/hooks/sort-group';
const { handleOptionsDisabled, fieldChange } = useSortGroup();
const useFilterList = useFilterListStore();
import useFields from '@/hooks/fields';
const { moveTypeOneToEnd } = useFields();
import fhDivider from '@/components/fh-divider/fh-divider.vue';
const props = defineProps({
  fieldList: {
    type: [Array],
    default: () => []
  },
  viewId: {
    type: [String, Number],
    default: ''
  },
  entity: {
    type: [String, Number],
    default: 1
  }
});
const showOverlay = ref(false);
const data = reactive({
  popupVisible: false,
  fieldSort: [],
  num: 0
});
const emits = defineEmits(['cbSort']);
const viewId = computed(() => props.viewId);
const visibleMap = ref({}); // 字段列表是否显示
const sortCount = ref(0);
const fieldLists = computed(() => {
  const _array = (props.fieldList || [])
    .filter((item) => constFieldSort?.includes(item.fieldType))
    .flatMap((item) => {
      if (item.fieldType === 9) {
        return [
          { ...item, fieldName: `${item.fieldName}-开始时间`, fieldKey: `${item.fieldKey}-begin`, copyFieldKey: item.fieldKey },
          { ...item, fieldName: `${item.fieldName}-结束时间`, fieldKey: `${item.fieldKey}-end`, copyFieldKey: item.fieldKey }
        ];
      }
      return [{ ...item, copyFieldKey: item.fieldKey }];
    });
  return moveTypeOneToEnd(_array);
});
// 处理禁用状态-打开时
const selectChangePopup = (event, element) => {
  if (!element?.fieldKey) return;
  const keys = element.fieldKey.split('-');
  fieldLists.value = fieldLists.value?.map((e) => {
    if (e.copyFieldKey == keys[0] && element.fieldKey) {
      e.disabled = !event;
    }
    return { ...e };
  });
};

// 设置排序
const setfieldSort = (element, type, index) => {
  element.fieldSort = type;
  data.fieldSort[index] = { fieldKey: element.fieldKey, fieldSort: type, fieldStatus: 1, isDefault: element?.isDefault, subProperty: element?.subProperty };
};

const addFieldSort = () => {
  if (data.fieldSort?.length < 5) {
    const obj = { fieldKey: '', fieldSort: true, fieldStatus: 1, isDefault: false, subProperty: '' };
    data.fieldSort.push(obj);
    const len = data.fieldSort.length - 1;
    visibleMap.value[`show-${len}`] = true;
  }
};

// 清除所有排序
// const clearAllSort = async () => {
//   data.fieldSort = [];
//   sortCount.value = 0;
//   visibleMap.value = {};
//   useFilterList.setFieldsSort([]);
//   // 清除用户自定义排序
//   await deleteUserSort();
//   visibleMap.value = {};
//   hideLay();
//   handleOptionsDisabled(data.fieldSort, fieldLists.value);
//   emits('cbSort', { isNull: true });
// };

// 打开排序
const openSortPopup = () => {
  const v = JSON.parse(JSON.stringify(useFilterList?.fieldsSort));
  // 日期范围特殊处理
  data.fieldSort =
    v?.map((item) => {
      if (item?.subProperty && item?.subProperty == 'begin') {
        item.fieldKey = item.fieldKey + '-begin';
      }
      if (item?.subProperty && item?.subProperty == 'end') {
        item.fieldKey = item.fieldKey + '-end';
      }
      return item;
    }) || [];
  // 处理options
  handleOptionsDisabled(data.fieldSort, fieldLists.value);
  if (data.fieldSort?.length == 0) {
    data.fieldSort = [{ fieldKey: '', fieldSort: true, fieldStatus: 1, isDefault: false, subProperty: '' }];
    visibleMap.value['show-0'] = true;
  }
  data.popupVisible = true;
  showOverlay.value = true;
};
const hideLay = async () => {
  showOverlay.value = false;
  data.popupVisible = false;
  visibleMap.value = {};
};
// 恢复默认
const defaultSortCondition = async () => {
  data.fieldSort = useFilterList.fieldsSortDefault;
  useFilterList.setFieldsSort([]);
  useFilterList.setFieldsSort(useFilterList.fieldsSortDefault);
  // 清除用户自定义排序
  await deleteUserSort();
  hideLay();
  emits('cbSort', { isDefault: true });
};
// 清空所有
const deleteSortConditionAll = async () => {
  data.fieldSort = [];
  // 清除用户自定义排序
  await deleteUserSort();
  handleOptionsDisabled(data.fieldSort, fieldLists.value);
};

const deleteSortField = (index) => {
  if (data.fieldSort.length == 1) {
    data.fieldSort = [];
  } else {
    data.fieldSort?.splice(index, 1);
  }
  handleOptionsDisabled(data.fieldSort, fieldLists.value);
};

// 清除用户自定义排序
const deleteUserSort = async () => {
  try {
    if (!useFilterList.sortId?.sId) {
      return;
    }
    const params = {
      id: useFilterList.sortId?.sId,
      entity: props.entity,
      viewId: viewId.value,
      sortList: []
    };
    const json = await layoutService.sortClear(params);
    if (json.error) {
      Message.error(json.error?.msg || '清除排序规则失败!');
    }
  } catch (e) {
    console.log(e);
  }
};

// 保存用户排序
const saveUserSort = async (arr) => {
  try {
    const params = {
      entity: props.entity,
      viewId: viewId.value,
      sortList: arr
    };
    const json = await layoutService.saveSortOrUpdate(params);
    if (json.error) {
      Message.error(json.error?.msg || '保存排序规则失败!');
    }
  } catch (e) {
    console.log(e);
  }
};

const sortConfirm = async () => {
  const arr = data.fieldSort?.filter((item) => item.fieldKey);
  // 日期范围特殊处理
  arr?.forEach((item) => {
    if (item.fieldKey?.includes('-')) {
      const _str = item.fieldKey?.split('-');
      if (_str[0]) {
        item.fieldKey = _str[0];
      }
      if (_str[1]) {
        item.subProperty = _str[1];
      }
    }
  });
  sortCount.value = arr?.length;
  console.log('存储store1111', arr);
  // 存store
  useFilterList.submitSortFn(arr || []);
  console.log('存储store222', useFilterList.fieldsSort);

  showOverlay.value = false;
  data.popupVisible = false;
  if (arr && arr?.length) {
    // 存接口
    await saveUserSort(arr);
  } else {
    // 清除用户自定义排序
    await deleteUserSort();
  }
  visibleMap.value = {};
  emits('cbSort');
};

watch(
  () => useFilterList?.fieldsSort,
  (v) => {
    console.log('AAA-触发了排序', v);
    // 兼容日期范围格式
    const _copyValue = JSON.parse(JSON.stringify(v));
    data.fieldSort =
      _copyValue?.map((item) => {
        if (item?.subProperty && item?.subProperty == 'begin') {
          item.fieldKey = item.fieldKey + '-begin';
        }
        if (item?.subProperty && item?.subProperty == 'end') {
          item.fieldKey = item.fieldKey + '-end';
        }
        return item;
      }) || [];
    sortCount.value = v?.filter((item) => item.fieldKey != '')?.length || 0;
  },
  {
    deep: true,
    immediate: true
  }
);
</script>
<style scoped lang="less">
@import './list-sort.less';
</style>
